import { memo } from 'react';
import { css } from '@emotion/react';
import { Handle, Position } from '@xyflow/react';
import { useTranslation } from '@frontend/i18n';
import { theme } from '@frontend/theme';
import { Text, useTooltip } from '@frontend/design-system';
import { SharedNodeProps } from '../data';
import { draggableStyles } from './styles';

export const FallbackNode = memo(({ data }: SharedNodeProps) => {
  const { t } = useTranslation('phone');
  const handles = {
    top: { id: 'top' },
    bottom: { id: 'bottom' },
  };

  const { tooltipProps, triggerProps, Tooltip } = useTooltip();

  return (
    <div css={draggableStyles} {...triggerProps}>
      <Handle
        type='target'
        position={Position.Top}
        id={handles.top.id}
        isConnectable={true}
        style={{ visibility: 'hidden' }}
      />
      <div
        style={{
          height: 24,
          padding: theme.spacing(0.25, 1),
          backgroundColor: theme.colors.neutral90,
          borderRadius: theme.borderRadius.small,
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
        }}
      >
        <Text as='span' color='white' size='medium'>
          {data.label}
        </Text>
      </div>
      <Handle
        type='source'
        position={Position.Bottom}
        id={handles.bottom.id}
        isConnectable={true}
        style={{ visibility: 'hidden' }}
      />
      <Tooltip
        {...tooltipProps}
        css={css`
          font-weight: 400;
        `}
      >
        {t(
          'The fallback is triggered when either the Phone Tree times out or the caller exceeds the maximum number of invalid selections.'
        )}
      </Tooltip>
    </div>
  );
});
FallbackNode.displayName = 'FallbackNode';
